"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    if (await knex.schema.hasTable(_globals.MetaTableOldV2.OUTLINE_VIEW)) {
        await knex.schema.renameTable(_globals.MetaTableOldV2.OUTLINE_VIEW, _globals.MetaTable.LIST_VIEW);
    }
    if (await knex.schema.hasTable(_globals.MetaTableOldV2.OUTLINE_VIEW_COLUMNS)) {
        await knex.schema.renameTable(_globals.MetaTableOldV2.OUTLINE_VIEW_COLUMNS, _globals.MetaTable.LIST_VIEW_COLUMNS);
    }
    if (await knex.schema.hasTable(_globals.MetaTableOldV2.OUTLINE_VIEW_LEVELS)) {
        await knex.schema.renameTable(_globals.MetaTableOldV2.OUTLINE_VIEW_LEVELS, _globals.MetaTable.LIST_VIEW_LEVELS);
    }
};
const down = async (knex)=>{
    if (await knex.schema.hasTable(_globals.MetaTable.LIST_VIEW)) {
        await knex.schema.renameTable(_globals.MetaTable.LIST_VIEW, _globals.MetaTableOldV2.OUTLINE_VIEW);
    }
    if (await knex.schema.hasTable(_globals.MetaTable.LIST_VIEW_COLUMNS)) {
        await knex.schema.renameTable(_globals.MetaTable.LIST_VIEW_COLUMNS, _globals.MetaTableOldV2.OUTLINE_VIEW_COLUMNS);
    }
    if (await knex.schema.hasTable(_globals.MetaTable.LIST_VIEW_LEVELS)) {
        await knex.schema.renameTable(_globals.MetaTable.LIST_VIEW_LEVELS, _globals.MetaTableOldV2.OUTLINE_VIEW_LEVELS);
    }
};
